<template>
  <div class="membership-form-container">
    <div class="signup-form">
      <!-- sign 姓名输入框 -->
      <div class="form-item-group">
        <div class="form-item-label">
          <label for="visaCardName">{{ $i18n.t('visaCardName') }}*</label>
        </div>
        <div class="form-item-component">
          <SafeInput
            :className="{
              'signup-form-item': true,
              'input-border-err': nameInfoErr || cardInfoErr,
            }"
            :type="nameInputType"
            id="visaCardName"
            :placeholder="$i18n.t('visaCardName')"
            autocomplete="new-password"
            role="input name"
            v-model.trim="formData.visaCardName"
            maxlength="35"
            minlength="2"
            @input="
              e => {
                handleValueChange(e, 'visaCardName');
              }
            "
          />
          <img
            v-show="showName"
            class="eye"
            src="~img/icon-feather-eye-on.svg"
            @click="changeNameInputStatus('password')"
            alt="hide name"
          />
          <img
            v-show="!showName"
            class="eye"
            src="~img/icon-feather-eye-off.svg"
            @click="changeNameInputStatus('text')"
            alt="show name"
          />
        </div>
        <!-- check 错误提示 -->
        <p v-if="nameInfoErr" class="error-message">{{ nameErrMsg }}</p>
      </div>
      <!-- signup 卡号输入框 -->
      <div class="form-item-group">
        <div class="form-item-label">
          <label for="visaCardNum">{{ $i18n.t('visaCardNum') }}*</label>
        </div>
        <div class="form-item-component">
          <SafeInput
            :className="{
              'signup-form-item': true,
              'input-border-err': cardNumInfoErr || cardInfoErr,
            }"
            :type="cardNumInputType"
            id="visaCardNum"
            :placeholder="$i18n.t('visaCardNum')"
            autocomplete="new-password"
            role="input card number"
            v-model.trim="formData.visaCardNum"
            maxlength="19"
            @input="
              e => {
                handleValueChange(e, 'visaCardNum');
              }
            "
          />
          <img
            v-show="showCardNum"
            class="eye"
            src="~img/icon-feather-eye-on.svg"
            @click="changeCardNumStatus('password')"
            alt="hide card number"
          />
          <img
            v-show="!showCardNum"
            class="eye"
            src="~img/icon-feather-eye-off.svg"
            @click="changeCardNumStatus('text')"
            alt="show card number"
          />
        </div>
        <!-- check 错误提示 -->
        <p v-if="cardNumInfoErr" class="error-message">{{ cardNumErrMsg }}</p>
      </div>
      <div class="form-layout-horizontal">
        <!-- signup 日期输入框 -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="cardExpiryDate">{{ $i18n.t('cardExpiryDate') }}*</label>
          </div>
          <div class="form-item-component">
            <SafeInput
              :className="{
                'signup-form-item': true,
                'input-border-err': expiryDateInfoErr || cardInfoErr,
              }"
              :type="expiryDateInputType"
              id="cardExpiryDate"
              :placeholder="$i18n.t('cardExpiryDate')"
              autocomplete="new-password"
              role="input expiryDate"
              v-model.trim="formData.cardExpiryDate"
              maxlength="5"
              @input="
                e => {
                  handleValueChange(e, 'cardExpiryDate');
                }
              "
            />
            <img
              v-show="showExpDate"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="changeExpiryDateStatus('password')"
              alt="hide expiryDate"
            />
            <img
              v-show="!showExpDate"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="changeExpiryDateStatus('text')"
              alt="show expiryDate"
            />
          </div>
          <!-- check 错误提示 -->
          <p v-if="expiryDateInfoErr" class="error-message">{{ expiryDateErrMsg }}</p>
        </div>
        <!-- signup cvv输入框 -->
        <div class="form-item-group">
          <div class="form-item-label">
            <label for="cardNum">{{ $i18n.t('cardNum') }}*</label>
            <img src="~img/icon-cvv.svg" alt="cvv" class="img-cvv" />
          </div>
          <div class="form-item-component">
            <SafeInput
              :className="{
                'signup-form-item': true,
                'input-border-err': cvvInfoErr || cardInfoErr,
              }"
              :type="cvvInputType"
              id="cardNum"
              :placeholder="$i18n.t('cardNum')"
              autocomplete="new-password"
              role="input CVV"
              v-model.trim="formData.cardNum"
              maxlength="4"
              @input="
                e => {
                  handleValueChange(e, 'cardNum');
                }
              "
            />
            <img
              v-show="showCVV"
              class="eye"
              src="~img/icon-feather-eye-on.svg"
              @click="changeCvvStatus('password')"
              alt="hide CVV"
            />
            <img
              v-show="!showCVV"
              class="eye"
              src="~img/icon-feather-eye-off.svg"
              @click="changeCvvStatus('text')"
              alt="show CVV"
            />
          </div>
          <!-- check 错误提示 -->
          <p v-if="cvvInfoErr" class="error-message">{{ cvvErrMsg }}</p>
        </div>
      </div>
    </div>
    <p v-if="cardInfoErr" class="error-message">{{ cardErrMsg }}</p>
  </div>
</template>
<script>
  import verify from '@/utils/verify';
  import SafeInput from '@/components/SafeInput/index.vue';

  export default {
    name: 'MembershipForm',
    components: {
      SafeInput,
    },
    props: {},
    data() {
      return {
        // 姓名输入框
        nameInputType: 'password',
        nameInfoErr: false,
        nameErrMsg: '',
        // 卡号输入框
        cardNumInputType: 'password',
        cardNumInfoErr: false,
        cardNumErrMsg: '',
        // 过期时间输入框
        expiryDateInputType: 'password',
        expiryDateInfoErr: false,
        expiryDateErrMsg: '',
        // CVV输入框
        cvvInputType: 'password',
        cvvInfoErr: false,
        cvvErrMsg: '',
        // 验证卡的错误信息
        cardInfoErr: false,
        // cardErrMsg: this.$i18n.t('not-eligible'),
        // cardErrMsg: `${this.$i18n.t('invalid-entry')}.${this.$i18n.t('please-check-details')}`,
        cardErrMsg: '',
        formData: {
          visaCardName: '',
          visaCardNum: '',
          cardExpiryDate: '',
          cardNum: '',
        },
        infoErr: false,
        errorMsg: '',
        loading: false,
        // 校验卡所需的参数
        projectId: '',
        visaToken: '',
        encryptCustomerInput: '',
        // 注册时需要传回的参数
        cardInfoToken: '',
      };
    },
    computed: {
      showName() {
        return this.nameInputType === 'text';
      },
      showCardNum() {
        return this.cardNumInputType === 'text';
      },
      showExpDate() {
        return this.expiryDateInputType === 'text';
      },
      showCVV() {
        return this.cvvInputType === 'text';
      },
      // 给父组件用, 父组件不需改动代码
      modalValue() {
        const { visaCardNum, visaCardName, cardNum, cardExpiryDate } = this.formData;
        return {
          visaCardNum: visaCardNum.replace(/\s+/g, ''),
          visaCardName,
          cardNum,
          cardExpiryDate,
          cdeDate: {
            expiryMonth: cardExpiryDate.split('/')[0],
            expiryYear: cardExpiryDate.split('/')[1],
          },
        };
      },
    },
    methods: {
      changeNameInputStatus(value) {
        this.nameInputType = value;
      },
      changeCardNumStatus(value) {
        this.cardNumInputType = value;
      },
      changeExpiryDateStatus(value) {
        this.expiryDateInputType = value;
      },
      changeCvvStatus(value) {
        this.cvvInputType = value;
      },
      checkCard() {
        verify({
          ...this.formData,
          visaCardNum: this.formData.visaCardNum.replace(/\s+/g, ''),
        }).then(async errMsg => {
          if (errMsg.pass) {
            console.log('校验通过');
          } else {
            errMsg.forEach(item => {
              switch (item.name) {
                case 'visaCardName':
                  this.nameInfoErr = true;
                  this.nameErrMsg = item.errMessage;
                  break;
                case 'visaCardNum':
                  this.cardNumInfoErr = true;
                  this.cardNumErrMsg = item.errMessage;
                  break;
                case 'cardExpiryDate':
                  this.expiryDateInfoErr = true;
                  this.expiryDateErrMsg = item.errMessage;
                  break;
                case 'cardNum':
                  this.cvvInfoErr = true;
                  this.cvvErrMsg = item.errMessage;
                  break;
                default:
                  break;
              }
            });
          }
        });
      },
      handleValueChange(e, key) {
        this.cardInfoErr = false;
        this.cardErrMsg = '';
        switch (key) {
          case 'visaCardName':
            this.nameInfoErr = false;
            this.nameErrMsg = '';
            break;
          case 'visaCardNum':
            this.cardNumInfoErr = false;
            this.cardNumErrMsg = '';
            break;
          case 'cardExpiryDate':
            this.expiryDateInfoErr = false;
            this.expiryDateErrMsg = '';
            break;
          case 'cardNum':
            this.cvvInfoErr = false;
            this.cvvErrMsg = '';
            break;
          default:
            break;
        }
        const { value } = e.target;
        if (key === 'visaCardNum') {
          const newValue = value
            .replace(/\s/g, '')
            .replace(/[^\d]/g, '')
            .replace(/(\d{4})(?=\d)/g, '$1 ');
          this.formData[key] = newValue;
        }
        if (key === 'cardNum') {
          // 判断cardNum当前的值是否为数字
          const newValue = value.replace(/\s/g, '').replace(/[^\d]/g, '');
          this.formData[key] = newValue;
        }
        if (key === 'cardExpiryDate') {
          // 判断cardExpiryDate当前的值是否为数字 + /
          const newValue = value
            .replace(/\s/g, '')
            .replace(/[^\d|/]/g, '')
            .replace(/(\d{2})(?=\d)/g, '$1/');
          this.formData[key] = newValue;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  @use './index';
  @use './mobile.scss';
</style>
